import { Sex } from 'app/constants/configuration/sex'

export const getSexName = (sex: Sex, translate: (string) => string): string => {
  const text: string = Sex[sex]
  return translate(`sex.${text}`)
}
